import React from 'react';
import {
  Section,
  SettingToggle,
  SettingsSectionBox,
  SettingsSectionLabel,
  SettingsSectionRow,
} from '@views/Settings/components';
import { useDispatch, useSelector } from 'react-redux';
import { setUserMetadataFlag } from '@actions/user';
import { UserMetadataFlag, selectUserMetadata } from '@reducers/user/metadata';

// This list should be exhaustive as we add more feature callouts
const configurableFlags: UserMetadataFlag[] = [
  'nexusCalloutDismissed',
  'requestBirthdaysCalloutDismissed',
  'accountProcessingToastDismissed',
  'forceShowImportingContactsAlert',
];

export default function UserCallouts() {
  const dispatch = useDispatch();
  const userMetadata = useSelector(selectUserMetadata);
  const isFlagSet = (flag: UserMetadataFlag) => userMetadata?.[flag] || false;
  const enableFlag = (flag: UserMetadataFlag) => dispatch(setUserMetadataFlag(flag, false));
  const dismissCallout = (flag: UserMetadataFlag) => dispatch(setUserMetadataFlag(flag, true));

  return (
    <Section>
      <SettingsSectionLabel>User Feature Callouts</SettingsSectionLabel>
      <SettingsSectionBox>
        {configurableFlags.map((flag) => (
          <SettingsSectionRow key={flag}>
            <SettingToggle
              title={`${flag} flag set on user`}
              name={flag}
              checked={isFlagSet(flag)}
              onChange={() => {
                if (isFlagSet(flag)) {
                  enableFlag(flag);
                } else {
                  dismissCallout(flag);
                }
              }}
            />
          </SettingsSectionRow>
        ))}
      </SettingsSectionBox>
    </Section>
  );
}
